<template>
    <LayoutMain>
        <SubSection class="job_offer" v-show="step === 0" v-if="!isLoading">
            <div class="form_wrap">
                <div class="inner">
                    <div class="title_area">
                        <h1 v-if="resumeIdx === ''">지원서 작성</h1>
                        <h1 v-else>지원서 수정</h1>
                    </div>
                    <ul class="progress_tracker">
                        <li class="progress_step">
                            <div class="step_wrap">
                                <span class="progress_marker is-active"></span>
                                <p class="progress_text">기본입력 사항</p>
                            </div>
                        </li>
                        <li class="progress_step">
                            <div class="step_wrap">
                                <span class="progress_marker"></span>
                                <p class="progress_text">학력 및 경력사항</p>
                            </div>
                        </li>
                        <li class="progress_step">
                            <div class="step_wrap">
                                <span class="progress_marker"></span>
                                <p class="progress_text">자기소개서</p>
                            </div>
                        </li>
                    </ul>
                    <section class="form_section">
                        <p class="section_title">지원자 기본 정보</p>
                        <form action="">
                            <div class="row">
                                <div class="picture">
                                    <div class="inner" @click="this.$refs.photo.click()">
                                        <div class="guide" v-if="previewImage === null">사진추가<br />(103 x 132 px)</div>
                                        <img :src="previewImage" alt="" v-else />
                                        <input type="file" name="" id="" ref="photo" accept="image/*"
                                            @change="changeImage" />
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="input_group">
                                        <div class="left_area">
                                            <p>이름 (한글)</p>
                                        </div>
                                        <div class="right_area">
                                            <input type="text" placeholder="한글명을 입력해주세요." class="w-360"
                                                v-model="resume.name" />
                                        </div>
                                    </div>
                                    <div class="input_group">
                                        <div class="left_area">
                                            <p>이름 (한자)</p>
                                        </div>
                                        <div class="right_area">
                                            <input type="text" placeholder="한문명을 입력해주세요." class="w-360"
                                                v-model="resume.hanName" />
                                        </div>
                                    </div>
                                    <div class="input_group">
                                        <div class="left_area">
                                            <p>이름 (영어)</p>
                                        </div>
                                        <div class="right_area">
                                            <input type="text" placeholder="영문명을 입력해주세요." class="w-360"
                                                v-model="resume.engName" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="input_group require">
                                    <span class="title">성별</span>
                                    <div class="radio_group">
                                        <label for="radio_1">
                                            <input type="radio" id="radio_1" name="cate01" v-model="resume.gender"
                                                value="M" />
                                            <span class="radio_box"></span>
                                            <span>남자</span>
                                        </label>
                                        <label for="radio_2">
                                            <input type="radio" id="radio_2" name="cate01" v-model="resume.gender"
                                                value="F" />
                                            <span class="radio_box"></span>
                                            <span>여자</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="input_group require">
                                    <span class="title">생년월일</span>
                                    <div class="input_row">
                                        <select class="w-190" v-model="resume.birth_comp_year">
                                            <option value="">연도 선택</option>
                                            <option v-for="year of yearSelect" :key="year" :value="year">{{ year }}
                                            </option>
                                        </select>
                                        <select class="w-190" v-model="resume.birth_comp_month">
                                            <option value="">월 선택</option>
                                            <option v-for="month of monthSelect" :key="month" :value="month">{{ month }}
                                            </option>
                                        </select>
                                        <select class="w-190" v-model="resume.birth_comp_day">
                                            <option value="">일 선택</option>
                                            <option v-for="day of daySelect" :key="day" :value="day">{{ day }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="input_group require">
                                    <span class="title">휴대폰 번호</span>
                                    <div class="input_row">
                                        <select class="w-190" v-model="resume.hpNo_comp_first">
                                            <option value="">선택</option>
                                            <option value="010">010</option>
                                            <option value="011">011</option>
                                            <option value="016">016</option>
                                            <option value="017">017</option>
                                            <option value="018">018</option>
                                            <option value="019">019</option>
                                        </select>
                                        <span class="dash">-</span>
                                        <input type="text" class="w-190" v-model="resume.hpNo_comp_second"
                                            maxlength="4" />
                                        <span class="dash">-</span>
                                        <input type="text" class="w-190" v-model="resume.hpNo_comp_third"
                                            maxlength="4" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="input_group">
                                    <span class="title">전화번호</span>
                                    <div class="input_row">
                                        <select class="w-190" v-model="resume.telNo_comp_first">
                                            <option value="">선택</option>
                                            <option value="02">02</option>
                                            <option value="051">051</option>
                                            <option value="053">053</option>
                                            <option value="032">032</option>
                                            <option value="062">062</option>
                                            <option value="042">042</option>
                                            <option value="052">052</option>
                                            <option value="044">044</option>
                                            <option value="031">031</option>
                                            <option value="033">033</option>
                                            <option value="043">043</option>
                                            <option value="041">041</option>
                                            <option value="063">063</option>
                                            <option value="061">061</option>
                                            <option value="054">054</option>
                                            <option value="055">055</option>
                                            <option value="064">064</option>
                                        </select>
                                        <span class="dash">-</span>
                                        <input type="text" class="w-190" v-model="resume.telNo_comp_second"
                                            maxlength="4" />
                                        <span class="dash">-</span>
                                        <input type="text" class="w-190" v-model="resume.telNo_comp_third"
                                            maxlength="4" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="input_group require">
                                    <span class="title">이메일</span>
                                    <div class="input_row">
                                        <input type="text" class="w-190" v-model="resume.email_comp_first" />
                                        <span>@</span>
                                        <input type="text" class="w-190" v-model="resume.email_comp_second"
                                            :disabled="!emailEditable" />
                                        <select class="w-260" @change="handleSelectChange">
                                            <option value="">직접 입력</option>
                                            <option value="naver.com">naver.com</option>
                                            <option value="daum.net">daum.net</option>
                                            <option value="gmail.com">gmail.com</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="input_group require">
                                    <span class="title">비밀번호</span>
                                    <input type="password" placeholder="비밀번호를 입력해주세요." class="w-712"
                                        v-model="resume.password" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="input_group require">
                                    <span class="title">주소</span>
                                    <div class="col">
                                        <div class="input_row">
                                            <input type="text" placeholder="우편번호" class="w-220" v-model="resume.zipNo"
                                                readonly />
                                            <button type="button" class="black_btn"
                                                @click="execDaumPostcode">검색하기</button>
                                        </div>
                                        <input type="text" placeholder="기본주소" class="w-712 mv-10" v-model="resume.addr1"
                                            readonly />
                                        <input type="text" placeholder="상세주소" class="w-712" v-model="resume.addr2" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="input_group require">
                                    <span class="title">보훈대상여부</span>
                                    <div class="radio_group">
                                        <label for="radio_3">
                                            <input type="radio" id="radio_3" name="cate02" v-model="resume.veteran"
                                                value="Y" />
                                            <span class="radio_box"></span>
                                            <span>대상</span>
                                        </label>
                                        <label for="radio_4">
                                            <input type="radio" id="radio_4" name="cate02" v-model="resume.veteran"
                                                value="N" />
                                            <span class="radio_box"></span>
                                            <span>비대상</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="input_group require pb-0">
                                    <span class="title">병역사항</span>
                                    <div class="col">
                                        <div class="radio_group">
                                            <label for="radio_5">
                                                <input type="radio" id="radio_5" name="cate03" v-model="resume.military"
                                                    value="Y" />
                                                <span class="radio_box"></span>
                                                <span>군필</span>
                                            </label>
                                            <label for="radio_6">
                                                <input type="radio" id="radio_6" name="cate03" v-model="resume.military"
                                                    value="N" />
                                                <span class="radio_box"></span>
                                                <span>미필(면제자 포함)</span>
                                            </label>
                                            <label for="radio_7">
                                                <input type="radio" id="radio_7" name="cate03" v-model="resume.military"
                                                    value="X" />
                                                <span class="radio_box"></span>
                                                <span>해당없음(여)</span>
                                            </label>
                                        </div>
                                        <div class="row military" v-if="resume.military !== 'X'">
                                            <div class="input_group" v-if="resume.military === 'Y'">
                                                <span class="title">군별</span>
                                                <select class="w-160" v-model="resume.miliKind">
                                                    <option value="">군별</option>
                                                    <option value="육군">육군</option>
                                                    <option value="해군">해군</option>
                                                    <option value="공군">공군</option>
                                                    <option value="해병">해병</option>
                                                    <option value="전경">전경</option>
                                                    <option value="의경">의경</option>
                                                    <option value="공익">공익</option>
                                                    <option value="기타">기타</option>
                                                </select>
                                            </div>
                                            <div class="input_group" v-if="resume.military === 'Y'">
                                                <span class="title">계급</span>
                                                <select class="w-160" v-model="resume.miliLevel">
                                                    <option value="">계급</option>
                                                    <option value="이병">이병</option>
                                                    <option value="일병">일병</option>
                                                    <option value="상병">상병</option>
                                                    <option value="병장">병장</option>
                                                    <option value="하사">하사</option>
                                                    <option value="중사">중사</option>
                                                    <option value="상사">상사</option>
                                                    <option value="원사">원사</option>
                                                    <option value="준위">준위</option>
                                                    <option value="소위">소위</option>
                                                    <option value="중위">중위</option>
                                                    <option value="대위">대위</option>
                                                    <option value="소령">소령</option>
                                                    <option value="중령">중령</option>
                                                    <option value="대령">대령</option>
                                                    <option value="준장">준장</option>
                                                    <option value="소장">소장</option>
                                                    <option value="중장">중장</option>
                                                    <option value="대장">대장</option>
                                                    <option value="기타">기타</option>
                                                </select>
                                            </div>
                                            <div class="input_group" v-if="resume.military === 'N'">
                                                <span class="title">면제사유</span>
                                                <input type="text" class="w-300" v-model="resume.exmptReason" placeholder="면제사유" />
                                            </div>
                                        </div>
                                        <div class="row" v-if="resume.military === 'Y'">
                                            <div class="input_group">
                                                <span class="title">복무기간</span>
                                                <div class="military_row">
                                                    <input type="text" class="w-200" placeholder="입대일자를 입력해주세요."
                                                        v-model="resume.miliStartDate" />
                                                    <span class="dash">~</span>
                                                    <input type="text" class="w-200" placeholder="전역일자를 입력해주세요."
                                                        v-model="resume.miliEndDate" />
                                                </div>
                                                <span class="info">예) 2003.01.05 ~ 2005.04.05</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="input_group require">
                                    <span class="title">기타</span>
                                    <div class="input_row">
                                        <div class="input_group p-0 row_center">
                                            <span class="title" style="flex:0 0 60px;">취미</span>
                                            <input type="text" class="w-250" v-model="resume.hobby" />
                                        </div>
                                        <div class="input_group p-0 row_center">
                                            <span class="title" style="flex:0 0 60px;">특기</span>
                                            <input type="text" class="w-250" v-model="resume.specialty" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="button_wrap">
                            <button class="black_btn" type="button" @click="nextStep">다음</button>
                        </div>
                    </section>
                </div>
            </div>
        </SubSection>

        <LoadingWrap v-else />

        <SubSection class="job_offer" v-show="step === 1">
            <div class="form_wrap">
                <div class="inner">
                    <div class="title_area">
                        <h1>지원서 작성</h1>
                    </div>
                    <ul class="progress_tracker">
                        <li class="progress_step">
                            <div class="step_wrap">
                                <span class="progress_marker is-complete"></span>
                                <p class="progress_text">기본입력 사항</p>
                            </div>
                        </li>
                        <li class="progress_step">
                            <div class="step_wrap">
                                <span class="progress_marker is-active"></span>
                                <p class="progress_text">학력 및 경력사항</p>
                            </div>
                        </li>
                        <li class="progress_step">
                            <div class="step_wrap">
                                <span class="progress_marker"></span>
                                <p class="progress_text">자기소개서</p>
                            </div>
                        </li>
                    </ul>
                    <section class="form_section">
                        <p class="section_title">학력 및 경력사항</p>
                        <form action="">
                            <div class="row">
                                <div class="input_group require">
                                    <span class="title">지원분야</span>
                                    <div class="input_row">
                                        <select class="w-384" v-model="resume.applyField">
                                            <option value="">선택</option>
                                            <option v-for="(applyItem, idx) of recruitInfor.applyField.split(',')"
                                                :value="applyItem" :key="idx">
                                                {{ applyItem }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <!-- <div class="input_group require" v-if="recruitInfor.cls === '경력'">
                                    <span class="title">희망근무지</span>
                                    <div class="input_row">
                                        <input type="text" class="w-384" v-model="resume.desiredLocation" />
                                    </div>
                                </div> -->
                            </div>
                            <div class="row" v-if="recruitInfor.cls === '경력'">
                                <div class="input_group require">
                                    <span class="title">현재연봉</span>
                                    <div class="input_row">
                                        <input type="text" class="w-384" v-model="resume.currentSalary" />
                                    </div>
                                </div>
                                <div class="input_group require">
                                    <span class="title">희망연봉</span>
                                    <div class="input_row">
                                        <input type="text" class="w-384" v-model="resume.desiredSalary" />
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="recruitInfor.cls === '경력'">
                                <div class="input_group require">
                                    <span class="title">입사가능일자</span>
                                    <div class="input_row">
                                        <label for="cate_year">
                                            <input type="text" id="cate_year" class="w-100"
                                                v-model="resume.availableYear" maxlength="4" />
                                            <span>년</span>
                                        </label>
                                        <label for="cate_month">
                                            <input type="text" id="cate_month" class="w-100"
                                                v-model="resume.availableMonth" maxlength="2" />
                                            <span>월</span>
                                        </label>
                                        <label for="cate_day">
                                            <input type="text" id="cate_day" class="w-100" v-model="resume.availableDay"
                                                maxlength="2" />
                                            <span>일</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <p class="sub_title ess">학력</p>
                        <form action="">
                            <table class="form_tbl">
                                <colgroup>
                                    <col width="184" />
                                    <col width="439" />
                                    <col width="111" />
                                    <col width="111" />
                                    <col width="111" />
                                    <col width="124" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>학교명</th>
                                        <th>재학 기간</th>
                                        <th>전공</th>
                                        <th>소재지</th>
                                        <th>성적</th>
                                        <th>
                                            <button class="black_btn" type="button"
                                                @click="() => iterableOjb(resume.educationList, tempEducationList).add()">
                                                추가
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) of resume.educationList" :key="idx">
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-143"
                                                    v-model="item.school" /></div>
                                        </td>
                                        <td>
                                            <div class="input_wrap">
                                                <label for="cate1_year">
                                                    <input type="text" id="cate1_year" class="w-64"
                                                        v-model="item.startYear" maxlength="4" />
                                                    <span>년</span>
                                                </label>
                                                <label for="cate1_month">
                                                    <input type="text" id="cate1_month" class="w-64"
                                                        v-model="item.startMonth" maxlength="2" />
                                                    <span>월</span>
                                                </label>
                                                <span class="center">~</span>
                                                <label for="cate1_year2">
                                                    <input type="text" id="cate1_year2" class="w-64"
                                                        v-model="item.endYear" maxlength="4" />
                                                    <span>년</span>
                                                </label>
                                                <label for="cate1_month2">
                                                    <input type="text" id="cate1_month2" class="w-64"
                                                        v-model="item.endMonth" maxlength="2" />
                                                    <span>월</span>
                                                </label>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-74"
                                                    v-model="item.major" /></div>
                                        </td>
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-74"
                                                    v-model="item.location" /></div>
                                        </td>
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-74"
                                                    v-model="item.score" /></div>
                                        </td>
                                        <td>
                                            <button class="white_btn" type="button"
                                                @click="iterableOjb(resume.educationList, tempEducationList).remove(idx)">
                                                삭제
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                        <p class="sub_title ess">경력</p>
                        <form action="">
                            <table class="form_tbl">
                                <colgroup>
                                    <col width="184" />
                                    <col width="439" />
                                    <col width="111" />
                                    <col width="111" />
                                    <col width="111" />
                                    <col width="124" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>회사명</th>
                                        <th>근무 기간</th>
                                        <th>최종직위</th>
                                        <th>담당업무</th>
                                        <th>퇴직사유</th>
                                        <th>
                                            <button class="black_btn" type="button"
                                                @click="() => iterableOjb(resume.careerList, tempCareerList).add()">
                                                추가
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) of resume.careerList" :key="idx">
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-143"
                                                    v-model="item.company" /></div>
                                        </td>
                                        <td>
                                            <div class="input_wrap">
                                                <label for="cate2_year">
                                                    <input type="text" id="cate2_year" class="w-64"
                                                        v-model="item.startYear" maxlength="4" />
                                                    <span>년</span>
                                                </label>
                                                <label for="cate2_month">
                                                    <input type="text" id="cate2_month" class="w-64"
                                                        v-model="item.startMonth" maxlength="2" />
                                                    <span>월</span>
                                                </label>
                                                <span class="center">~</span>
                                                <label for="cate2_year2">
                                                    <input type="text" id="cate2_year2" class="w-64"
                                                        v-model="item.endYear" maxlength="4" />
                                                    <span>년</span>
                                                </label>
                                                <label for="cate2_month2">
                                                    <input type="text" id="cate2_month2" class="w-64"
                                                        v-model="item.endMonth" maxlength="2" />
                                                    <span>월</span>
                                                </label>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-74"
                                                    v-model="item.position" /></div>
                                        </td>
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-74"
                                                    v-model="item.job" /></div>
                                        </td>
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-74"
                                                    v-model="item.retireReason" /></div>
                                        </td>
                                        <td>
                                            <button class="white_btn" type="button"
                                                @click="iterableOjb(resume.careerList, tempCareerList).remove(idx)">
                                                삭제
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                        <p class="sub_title ess">어학</p>
                        <form action="">
                            <table class="form_tbl">
                                <colgroup>
                                    <col width="184" />
                                    <col width="410" />
                                    <col width="182" />
                                    <col width="181" />
                                    <col width="123" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>시험명</th>
                                        <th>취득일</th>
                                        <th>점수(등급)</th>
                                        <th>언어</th>
                                        <th>
                                            <button class="black_btn" type="button"
                                                @click="() => iterableOjb(resume.languageList, tempLanguageList).add()">
                                                추가
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) of resume.languageList" :key="idx">
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-143"
                                                    v-model="item.testNm" /></div>
                                        </td>
                                        <td>
                                            <div class="input_wrap">
                                                <label for="cate3_year">
                                                    <input type="text" id="cate3_year" class="w-94"
                                                        v-model="item.issueYear" maxlength="4" />
                                                    <span>년</span>
                                                </label>
                                                <label for="cate3_month">
                                                    <input type="text" id="cate3_month" class="w-94"
                                                        v-model="item.issueMonth" maxlength="2" />
                                                    <span>월</span>
                                                </label>
                                                <label for="cate3_day">
                                                    <input type="text" id="cate3_day" class="w-94"
                                                        v-model="item.issueDay" maxlength="2" />
                                                    <span>일</span>
                                                </label>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-143"
                                                    v-model="item.testScore" /></div>
                                        </td>
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-143"
                                                    v-model="item.issueInsti" /></div>
                                        </td>
                                        <td>
                                            <button class="white_btn" type="button"
                                                @click="iterableOjb(resume.languageList, tempLanguageList).remove(idx)">
                                                삭제
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                        <p class="sub_title ess">면허 및 자격증</p>
                        <form action="">
                            <table class="form_tbl">
                                <colgroup>
                                    <col width="184" />
                                    <col width="410" />
                                    <col width="182" />
                                    <col width="181" />
                                    <col width="123" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>자격증명</th>
                                        <th>취득일</th>
                                        <th>등급</th>
                                        <th>발행처</th>
                                        <th>
                                            <button class="black_btn" type="button"
                                                @click="() => iterableOjb(resume.licenseList, tempLicenseList).add()">
                                                추가
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) of resume.licenseList" :key="idx">
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-143"
                                                    v-model="item.licenseNm" /></div>
                                        </td>
                                        <td>
                                            <div class="input_wrap">
                                                <label for="cate4_year">
                                                    <input type="text" id="cate4_year" class="w-94"
                                                        v-model="item.issueYear" maxlength="4" />
                                                    <span>년</span>
                                                </label>
                                                <label for="cate4_month">
                                                    <input type="text" id="cate4_month" class="w-94"
                                                        v-model="item.issueMonth" maxlength="2" />
                                                    <span>월</span>
                                                </label>
                                                <label for="cate4_day">
                                                    <input type="text" id="cate4_day" class="w-94"
                                                        v-model="item.issueDay" maxlength="2" />
                                                    <span>일</span>
                                                </label>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-143"
                                                    v-model="item.grade" /></div>
                                        </td>
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-143"
                                                    v-model="item.issueInsti" /></div>
                                        </td>
                                        <td>
                                            <button class="white_btn" type="button"
                                                @click="iterableOjb(resume.licenseList, tempLicenseList).remove(idx)">
                                                삭제
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                        <p class="sub_title ess">수상경력</p>
                        <form action="">
                            <table class="form_tbl">
                                <colgroup>
                                    <col width="184" />
                                    <col width="410" />
                                    <col width="182" />
                                    <col width="181" />
                                    <col width="121" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>수상내역</th>
                                        <th>취득일</th>
                                        <th>점수</th>
                                        <th>단체명</th>
                                        <th>
                                            <button class="black_btn" type="button"
                                                @click="() => iterableOjb(resume.awardList, tempAwardList).add()">
                                                추가
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) of resume.awardList" :key="idx">
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-143"
                                                    v-model="item.awardNm" /></div>
                                        </td>
                                        <td>
                                            <div class="input_wrap">
                                                <label for="cate5_year">
                                                    <input type="text" id="cate5_year" class="w-94"
                                                        v-model="item.issueYear" maxlength="4" />
                                                    <span>년</span>
                                                </label>
                                                <label for="cate5_month">
                                                    <input type="text" id="cate5_month" class="w-94"
                                                        v-model="item.issueMonth" maxlength="2" />
                                                    <span>월</span>
                                                </label>
                                                <label for="cate5_day">
                                                    <input type="text" id="cate5_day" class="w-94"
                                                        v-model="item.issueDay" maxlength="2" />
                                                    <span>일</span>
                                                </label>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-143"
                                                    v-model="item.score" /></div>
                                        </td>
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-143"
                                                    v-model="item.issueInsti" /></div>
                                        </td>
                                        <td>
                                            <button class="white_btn" type="button"
                                                @click="iterableOjb(resume.awardList, tempAwardList).remove(idx)">
                                                삭제
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                        <p class="sub_title ess">봉사활동</p>
                        <form action="">
                            <table class="form_tbl">
                                <colgroup>
                                    <col width="322" />
                                    <col width="318" />
                                    <col width="319" />
                                    <col width="121" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>봉사기관</th>
                                        <th>봉사내용</th>
                                        <th>봉사 총 시간</th>
                                        <th>
                                            <button class="black_btn" type="button"
                                                @click="() => iterableOjb(resume.serviceList, tempServiceList).add()">
                                                추가
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) of resume.serviceList" :key="idx">
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-280"
                                                    v-model="item.serviceInstitution" /></div>
                                        </td>
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-280"
                                                    v-model="item.serviceContent" /></div>
                                        </td>
                                        <td>
                                            <div class="input_wrap"><input type="text" class="w-280"
                                                    v-model="item.serviceTime" /></div>
                                        </td>
                                        <td>
                                            <button class="white_btn" type="button"
                                                @click="iterableOjb(resume.serviceList, tempServiceList).remove(idx)">
                                                삭제
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                        <div class="button_wrap">
                            <button class="white_btn" type="button" @click="prevStep">이전</button>
                            <button class="black_btn" type="button" @click="nextStep">다음</button>
                        </div>
                    </section>
                </div>
            </div>
        </SubSection>

        <SubSection class="job_offer" v-show="step === 2">
            <div class="form_wrap">
                <div class="inner">
                    <div class="title_area">
                        <h1>지원서 작성</h1>
                    </div>
                    <ul class="progress_tracker">
                        <li class="progress_step">
                            <div class="step_wrap">
                                <span class="progress_marker is-complete"></span>
                                <p class="progress_text">기본입력 사항</p>
                            </div>
                        </li>
                        <li class="progress_step">
                            <div class="step_wrap">
                                <span class="progress_marker is-complete"></span>
                                <p class="progress_text">학력 및 경력사항</p>
                            </div>
                        </li>
                        <li class="progress_step">
                            <div class="step_wrap">
                                <span class="progress_marker is-active"></span>
                                <p class="progress_text">자기소개서</p>
                            </div>
                        </li>
                    </ul>
                    <section class="form_section">
                        <p class="section_title">자기소개서</p>
                        <form v-if="recruitInfor.cls === '신입'">
                            <div class="textarea_group">
                                <p>01. 귀하의 성장과정을 기술하여 주십시오. (한글 400자 이내)</p>
                                <textarea name="" id="" v-model="resume.growingUp" maxlength="400"></textarea>
                            </div>
                            <div class="textarea_group">
                                <p>02. 귀하의 성격의 장단점을 기술하여 주십시오. (한글 400자 이내)</p>
                                <textarea name="" id="" v-model="resume.personality" maxlength="400"></textarea>
                            </div>
                            <div class="textarea_group">
                                <p>03. 귀하의 교내외 활동사항 및 주요경력을 기술하여 주십시오. (한글 400자 이내)</p>
                                <textarea name="" id="" v-model="resume.activities" maxlength="400"></textarea>
                            </div>
                            <div class="textarea_group">
                                <p>04. 귀하의 다른사람과 구별되는 지식/재능을 기술하여 주십시오. (한글 400자 이내)</p>
                                <textarea name="" id="" v-model="resume.specialTalent" maxlength="400"></textarea>
                            </div>
                            <div class="textarea_group">
                                <p>05. 귀하의 지원동기 및 입사 후 자기계발 계획을 기술하여 주십시오. (한글 400자 이내)</p>
                                <textarea name="" id="" v-model="resume.applyReason" maxlength="400"></textarea>
                            </div>
                            <div class="textarea_group">
                                <p>06. 귀하의 인생관/직업관을 기술하여 주십시오. (한글 400자 이내)</p>
                                <textarea name="" id="" v-model="resume.philosophyc" maxlength="400"></textarea>
                            </div>
                        </form>
                        <form v-if="recruitInfor.cls === '경력'">
                            <div class="textarea_group">
                                <p>01. 귀하의 성장과정을 기술하여 주십시오. (한글 400자 이내)</p>
                                <textarea name="" id="" v-model="resume.growingUp" maxlength="400"></textarea>
                            </div>
                            <div class="textarea_group">
                                <p>02. 귀하의 성격의 장단점을 기술하여 주십시오. (한글 400자 이내)</p>
                                <textarea name="" id="" v-model="resume.personality" maxlength="400"></textarea>
                            </div>
                            <div class="textarea_group">
                                <p>03. 귀하의 지원동기 및 입사 후 자기계발 계획을 기술하여 주십시오. (한글 400자 이내)</p>
                                <textarea name="" id="" v-model="resume.applyReason" maxlength="400"></textarea>
                            </div>
                            <div class="textarea_group">
                                <p>04. 귀하의 인생관/직업관을 기술하여 주십시오. (한글 400자 이내)</p>
                                <textarea name="" id="" v-model="resume.philosophyc" maxlength="400"></textarea>
                            </div>
                            <div class="textarea_group">
                                <p>05. 귀하의 경력을 기술하여 주십시오. (한글 400자 이내)</p>
                                <textarea name="" id="" v-model="resume.activities" maxlength="400"></textarea>
                            </div>
                        </form>
                        <div class="textarea_group consent_group">
                            <div class="consent_row">
                                <div class="consent_head">
                                    <p>개인정보 수집 및 이용 동의 (필수)</p>
                                    <button type="button" class="text_btn" @click="toggleConsentModal">[내용보기]</button>
                                </div>
                                <label for="privacy_consent" class="checkbox_label">
                                    <input type="checkbox" id="privacy_consent" v-model="agreePrivacy" />
                                    <span class="check_box"></span>
                                    <span>동의</span>
                                </label>
                            </div>
                            <div class="consent_row">
                                <div class="consent_head">
                                    <p>신용정보 조회를 위한 제3자 제공 동의 (필수)</p>
                                    <button type="button" class="text_btn" @click="toggleCreditConsentModal">[내용보기]</button>
                                </div>
                                <label for="credit_info_consent" class="checkbox_label">
                                    <input type="checkbox" id="credit_info_consent" v-model="agreeCreditInfoProvision" />
                                    <span class="check_box"></span>
                                    <span>동의</span>
                                </label>
                            </div>
                        </div>
                        <div class="button_wrap">
                            <button class="white_btn" type="button" @click="prevStep">이전</button>
                            <button v-if="resumeIdx === ''" class="black_btn" type="button" @click="submit">지원서
                                제출</button>
                            <button v-else class="black_btn" type="button" @click="submit">지원서 수정</button>
                        </div>
                    </section>
                </div>
            </div>
        </SubSection>
    </LayoutMain>

    <div class="modal_container consent_modal" v-if="consentModalOpen" @click.stop>
        <div class="modal_wrapper modal" @click.stop>
            <div class="modal_header">
                <p>개인정보 수집 및 이용 동의</p>
                <button class="modal_close" @click="toggleConsentModal">
                    <img src="@/assets/ic_close.png" alt="" />
                </button>
            </div>
            <div class="modal_body" data-lenis-prevent>
                <div class="consent_content">
                    <p class="consent_title">▣ 개인정보 수집 및 이용 동의</p>
                    <p>
                        한국정보통신㈜는 직원을 채용함에 있어 [개인정보보호법] 제15조 제1항 제1호, 제23조 제1호,
                        제24조 제1항 제1호, [신용정보의이용및보호에관한법률] 제32조 제1항, 제33조 및 제34조에 따라 아래와 같이
                        개인(신용)정보를 수집∙이용 및 조회함에 관하여 직원(입사지원자)의 동의를 얻고자 합니다.
                    </p>

                    <p class="consent_sub_title">가. 개인(신용)정보 수집∙이용 내역</p>
                    <table class="consent_table">
                        <thead>
                            <tr>
                                <th>목 적</th>
                                <th>수집하는 개인정보 항목</th>
                                <th>보유∙이용기간</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style="font-weight: 700;">채용 전형 진행<br />채용 결과 안내</td>
                                <td style="color: blue; font-weight: 700;">
                                    사진<br />
                                    성명(한글/영문/한자)<br />
                                    생년월일<br />
                                    성별<br />
                                    주소<br />
                                    연락처<br />
                                    이메일주소<br />
                                    학력<br />
                                    경력<br />
                                    병역<br />
                                    보훈 대상 여부<br />
                                    어학성적<br />
                                    면허∙자격<br />
                                    봉사활동이력<br />
                                    수상경력<br />
                                    취미∙특기
                                </td>
                                <td style="color: blue; text-decoration: underline; font-weight: 700;">채용 절차의 공정화에 관한 법률 및 그 시행령에 따름 <br>(채용 전형 종료 후 180일까지)</td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="consent_notice">
                        ※ 위의 개인(신용)정보 수집∙이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 채용 전형 상의
                        불이익을 받으실 수 있음을 알려드립니다.
                    </p>

                </div>
            </div>
        </div>
    </div>

    <div class="modal_container consent_modal" v-if="creditConsentModalOpen" @click.stop>
        <div class="modal_wrapper modal" @click.stop>
            <div class="modal_header">
                <p>신용정보 조회를 위한 제3자 제공 동의</p>
                <button class="modal_close" @click="toggleCreditConsentModal">
                    <img src="@/assets/ic_close.png" alt="" />
                </button>
            </div>
            <div class="modal_body" data-lenis-prevent>
                <div class="consent_content">
                    <p class="consent_title">▣ 개인정보 수집 및 이용 동의</p>
                    <p>
                        한국정보통신㈜는 직원을 채용함에 있어 [개인정보보호법] 제15조 제1항 제1호, 제23조 제1호,
                        제24조 제1항 제1호, [신용정보의이용및보호에관한법률] 제32조 제1항, 제33조 및 제34조에 따라 아래와 같이
                        개인(신용)정보를 수집∙이용 및 조회함에 관하여 직원(입사지원자)의 동의를 얻고자 합니다.
                    </p>

                    <p class="consent_sub_title">나. 신용정보 조회를 위한 제3자 제공에 대한 동의</p>
                    <table class="consent_table" style="font-weight: 700;">
                        <thead>
                            <tr>
                                <th>제공받은 기관</th>
                                <th>제공 목적</th>
                                <th>제공 항목</th>
                                <th>제공 기간</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style="color: blue; text-decoration: underline;">NICE 신용평가정보㈜</td>
                                <td style="color: blue;">신용정보요약통계<br />연체∙개설∙보증∙조회∙관계거래처 정보의 조회</td>
                                <td style="color: blue;">성명, 생년월일, 주소</td>
                                <td style="color: blue; text-decoration: underline;" rowspan="2">채용 여부 확정 시까지</td>
                            </tr>
                            <tr>
                                <td style="color: blue; text-decoration: underline;">국가보훈처</td>
                                <td style="color: blue;">보훈 우대 대상 검증</td>
                                <td style="color: blue;">성명, 생년월일, 보훈번호</td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="consent_notice">
                        ※ 위의 신용정보 조회를 위한 제3자 제공에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 채용 전형 상의 불이익을
                        받으실 수 있음을 알려드립니다.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getResumeDetail, resumeDetail, resumeInsertAction, resumeUpdate } from '@/api';
import LoadingWrap from '@/components/LoadingWrap.vue';
import SubSection from '@/components/SubSection.vue';
import LayoutMain from '@/layouts/LayoutMain.vue';

export default {
    components: {
        LayoutMain,
        SubSection,
        LoadingWrap,
    },
    data() {
        const yearSelect = [];
        const startYear = new Date().getFullYear() - 60;
        const endYear = new Date().getFullYear() - 20;
        for (let i = startYear; i <= endYear; i++) {
            yearSelect.push(i);
        }
        const monthSelect = Array.from({ length: 12 }, (_, idx) => idx + 1);
        const daySelect = Array.from({ length: 31 }, (_, idx) => idx + 1);

        const recruitIdx = this.$route.query?.recruitIdx || '';
        const resumeIdx = this.$route.query?.resumeIdx || '';

        return {
            isSubmit: false,
            isLoading: false,
            recruitIdx,
            resumeIdx,
            recruitInfor: {
                applyField: '',
            },
            step: 0,
            emailEditable: true,
            yearSelect,
            monthSelect,
            daySelect,
            previewImage: null,
            agreePrivacy: false,
            agreeCreditInfoProvision: false,
            consentModalOpen: false,
            creditConsentModalOpen: false,
            resume: {
                name: '',
                recruitIdx,
                applyYn: 'Y',
                engName: '',
                hanName: '',
                gender: 'M',
                birthDate: '',
                birth_comp_year: yearSelect[yearSelect.length - 1],
                birth_comp_month: monthSelect[0],
                birth_comp_day: daySelect[0],
                hpNo: '',
                hpNo_comp_first: '',
                hpNo_comp_second: '',
                hpNo_comp_third: '',
                telNo: '',
                telNo_comp_first: '',
                telNo_comp_second: '',
                telNo_comp_third: '',
                email_comp_first: '',
                email_comp_second: '',
                password: '',
                veteran: 'N',
                military: 'Y',
                miliKind: '',
                miliLevel: '',
                zipNo: '',
                addr1: '',
                addr2: '',
                miliStartDate: '',
                miliEndDate: '',
                exmptReason: '',
                hobby: '',
                specialty: '',
                applyField: '',
                desiredLocation: '',
                currentSalary: '',
                desiredSalary: '',
                availableDate: '',
                availableYear: '',
                availableMonth: '',
                availableDay: '',
                educationList: [
                    {
                        school: '',
                        startYear: '',
                        endYear: '',
                        startMonth: '',
                        endMonth: '',
                        startDate: '',
                        endDate: '',
                        major: '',
                        location: '',
                        score: '',
                    },
                ],
                careerList: [],
                languageList: [],
                licenseList: [],
                awardList: [],
                serviceList: [],
                growingUp: '',
                personality: '',
                activities: '',
                specialTalent: '',
                applyReason: '',
                philosophyc: '',
            },
            tempEducationList: {
                school: '',
                startYear: '',
                endYear: '',
                startMonth: '',
                endMonth: '',
                startDate: '',
                endDate: '',
                major: '',
                location: '',
                score: '',
            },
            tempCareerList: {
                company: '',
                startDate: '',
                endDate: '',
                startYear: '',
                endYear: '',
                startMonth: '',
                endMonth: '',
                position: '',
                job: '',
                retireReason: '',
            },
            tempLanguageList: {
                testNm: '',
                issueDate: '',
                issueYear: '',
                issueMonth: '',
                issueDay: '',
                testScore: '',
                issueInsti: '',
            },
            tempLicenseList: {
                licenseNm: '',
                issueDate: '',
                issueYear: '',
                issueMonth: '',
                issueDay: '',
                grade: '',
                issueInsti: '',
            },
            tempAwardList: {
                awardNm: '',
                issueDate: '',
                issueYear: '',
                issueMonth: '',
                issueDay: '',
                score: '',
                issueInsti: '',
            },
            tempServiceList: {
                serviceInstitution: '',
                serviceContent: '',
                serviceTime: '',
            },
        };
    },
    async mounted() {
        if (this.recruitIdx === '') {
            this.$router.push({ path: `/recruit/recruitment_notice` });
        } else {
            const result = await getResumeDetail(this.recruitIdx);
            if ('err' in result) {
                alert('존재하지 않는 공고입니다.');
                this.$router.push({ path: `/recruit/recruitment_notice` });
            } else {
                this.recruitInfor = result.data;

                if (this.resumeIdx !== '') {
                    try{
                        this.isLoading = true;
                        console.log(this.recruitInfor)
                        const storedName =
                            typeof window !== 'undefined' && window.sessionStorage ? window.sessionStorage.getItem('resumeName') || '' : '';
                        if (typeof window !== 'undefined' && window.sessionStorage) {
                            window.sessionStorage.removeItem('resumeName');
                        }
                        const editResult = await resumeDetail(this.resumeIdx, storedName);

                        delete editResult.data.nameEnc;
                        delete editResult.data.hanNameEnc;
                        delete editResult.data.engNameEnc;
                        delete editResult.data.genderEnc;
                        delete editResult.data.birthDateEnc;
                        delete editResult.data.hpNoEnc;
                        delete editResult.data.telNoEnc;
                        delete editResult.data.emailEnc;
                        delete editResult.data.zipNoEnc;
                        delete editResult.data.addr1Enc;
                        delete editResult.data.addr2Enc;

                        delete editResult.data.familyList;

                        this.resume = editResult.data;
                        this.resume.birth_comp_year = +this.resume.birthDate.slice(0, 4);
                        this.resume.birth_comp_month = +this.resume.birthDate.slice(4, 6);
                        this.resume.birth_comp_day = +this.resume.birthDate.slice(6);

                        const [hp1, hp2, hp3] = this.phoneNumberSplite(this.resume.hpNo);
                        this.resume.hpNo_comp_first = String(hp1);
                        this.resume.hpNo_comp_second = String(hp2);
                        this.resume.hpNo_comp_third = String(hp3);

                        const [tel1, tel2, tel3] = this.phoneNumberSplite(this.resume.telNo);
                        this.resume.telNo_comp_first = String(tel1);
                        this.resume.telNo_comp_second = String(tel2);
                        this.resume.telNo_comp_third = String(tel3);

                        const [email1, email2] = this.resume.email.split('@');
                        this.resume.email_comp_first = email1;
                        this.resume.email_comp_second = email2;

                        delete this.resume.password;
                        this.previewImage = this.resume.filePath;

                        const [av1, av2, av3] = this.dateSplit(this.resume.availableDate);
                        this.resume.availableYear = av1;
                        this.resume.availableMonth = av2;
                        this.resume.availableDay = av3;

                        this.resume.educationList.forEach((el) => {
                            el.startYear = el.startDate.split('.')[0];
                            el.startMonth = el.startDate.split('.')[1];
                            el.endYear = el.endDate.split('.')[0];
                            el.endMonth = el.endDate.split('.')[1];
                        });

                        this.resume.careerList.forEach((el) => {
                            el.startYear = el.startDate.split('.')[0];
                            el.startMonth = el.startDate.split('.')[1];
                            el.endYear = el.endDate.split('.')[0];
                            el.endMonth = el.endDate.split('.')[1];
                        });

                        this.resume.languageList.forEach((el) => {
                            el.issueYear = el.issueDate.split('.')[0];
                            el.issueMonth = el.issueDate.split('.')[1];
                            el.issueDay = el.issueDate.split('.')[2];
                        });

                        this.resume.licenseList.forEach((el) => {
                            el.issueYear = el.issueDate.split('.')[0];
                            el.issueMonth = el.issueDate.split('.')[1];
                            el.issueDay = el.issueDate.split('.')[2];
                        });

                        this.resume.awardList.forEach((el) => {
                            el.issueYear = el.issueDate.split('.')[0];
                            el.issueMonth = el.issueDate.split('.')[1];
                            el.issueDay = el.issueDate.split('.')[2];
                        });

                        this.isLoading = false;
                    }catch(err){
                        console.log(err);
                        alert('다시 시도해주세요.');
                        this.$router.push({ path: `/recruit/recruitment_notice` });
                    }
                }
            }
        }
    },
    methods: {
        phoneNumberSplite(number) {
            if (number.length === 11) {
                return [number.slice(0, 3), number.slice(3, 7), number.slice(7)];
            } else if (number.length === 9) {
                return [number.slice(0, 2), number.slice(2, 4), number.slice(4)];
            } else {
                if (number.slice(0, 2) === '02') {
                    return [number.slice(0, 2), number.slice(2, 6), number.slice(6)];
                } else {
                    return [number.slice(0, 3), number.slice(3, 6), number.slice(6)];
                }
            }
        },
        dateSplit(date) {
            if (date.length === 6) {
                return [date.slice(0, 4), date.slice(4, 6)];
            } else {
                return [date.slice(0, 4), date.slice(4, 6), date.slice(6, 8)];
            }
        },
        nextStep() {
            if (this.step === 0) if (!this.pageCheckOne()) return;
            if (this.step === 1) if (!this.pageCheckTwo()) return;
            this.step += 1;
            if (this.step > 2) this.step === 2;
            this.$lenis.scrollTo(0, 0);
        },
        prevStep() {
            this.step -= 1;
            if (this.step < 0) this.step === 0;
            this.$lenis.scrollTo(0, 0);
        },
        pageCheckOne() {
            if (this.resumeIdx === '') if (this.$refs.photo.files.length === 0) return alert('사진을 등록해주세요.');
            if (this.resume.name === '') return alert('이름을 입력해주세요.');
            else if (!/^[가-힣]{2,5}$/.test(this.resume.name)) return alert('이름을 확인해주세요.');
            if (this.resume.engName === '') return alert('영문이름을 입력해주세요.');
            else if (!/^[A-Za-z]+(?:\s[A-Za-z]+)?$/.test(this.resume.engName)) return alert('영문이름을 확인해주세요.');
            // 한자이름 검증은 사용하지 않음

            if (this.resume.hpNo_comp_first === '') return alert('휴대폰번호를 입력해주세요.');
            if (this.resume.hpNo_comp_second === '') return alert('휴대폰번호를 입력해주세요.');
            else if (!/^\d{3,4}$/.test(this.resume.hpNo_comp_second)) return alert(`휴대폰번호를 확인해주세요.`);
            if (this.resume.hpNo_comp_third === '') return alert('휴대폰번호를 입력해주세요.');
            else if (!/^\d{4}$/.test(this.resume.hpNo_comp_third)) return alert(`휴대폰번호를 확인해주세요.`);

            // if (this.resume.telNo_comp_first === '') return alert('전화번호를 입력해주세요.');
            // if (this.resume.telNo_comp_second === '') return alert('전화번호를 입력해주세요.');
            // else if (!/^\d{3,4}$/.test(this.resume.telNo_comp_second)) return alert(`전화번호를 확인해주세요.`);
            // if (this.resume.telNo_comp_third === '') return alert('전화번호를 입력해주세요.');
            // else if (!/^\d{4}$/.test(this.resume.telNo_comp_third)) return alert(`전화번호를 확인해주세요.`);

            if (this.resume.email_comp_first === '') return alert('이메일을 입력해주세요.');
            else if (!/^[a-zA-Z0-9._-]{1,64}$/.test(this.resume.email_comp_first)) return alert(`이메일을 확인해주세요.`);
            if (this.resume.email_comp_second === '') return alert('이메일을 입력해주세요.');
            else if (!/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.resume.email_comp_second)) return alert(`이메일을 확인해주세요.`);

            if (this.resumeIdx === '') if (this.resume.password === '') return alert('비밀번호를 입력해주세요.');

            if (this.resume.zipNo === '') return alert('주소를 입력해주세요.');
            if (this.resume.addr1 === '') return alert('주소를 입력해주세요.');
            if (this.resume.addr2 === '') return alert('주소를 입력해주세요.');

            if (this.resume.military === 'Y') {
                if (this.resume.miliKind === '') return alert('군별을 선택해주세요.');
                if (this.resume.miliLevel === '') return alert('계급을 선택해주세요.');
                if (this.resume.miliStartDate === '') return alert('입대일을 입력해주세요.');
                else if (!/^(19|20|21)\d{2}\.(0[1-9]|1[0-2])\.(0[1-9]|[12][0-9]|3[01])$/.test(this.resume.miliStartDate))
                    return alert(`입대일자는 yyyy.mm.dd 형식으로 입력해주세요.`);
                if (this.resume.miliEndDate === '') return alert('전역일을 입력해주세요.');
                else if (!/^(19|20|21)\d{2}\.(0[1-9]|1[0-2])\.(0[1-9]|[12][0-9]|3[01])$/.test(this.resume.miliEndDate))
                    return alert(`전역일자는 yyyy.mm.dd 형식으로 입력해주세요.`);
            }

            if (this.resume.military === 'N') {
                if (this.resume.exmptReason === '') return alert('면제사유를 입력해주세요.');
            }

            if (this.resume.hobby === '') return alert('취미를 입력해주세요.');
            if (this.resume.specialty === '') return alert('특기를 입력해주세요.');

            return true;
        },
        pageCheckTwo() {
            if (this.resume.applyField === '') return alert('지원분야를 선택해주세요.');
            if (this.recruitInfor.cls === '경력') {
                // if (this.resume.desiredLocation === '') return alert('희망근무지를 입력해주세요.');
                if (this.resume.currentSalary === '') return alert('현재연봉을 입력해주세요.');
                if (this.resume.desiredSalary === '') return alert('희망연봉을 입력해주세요.');
                if (this.resume.availableYear === '') return alert('입사가능일자를 입력해주세요.');
                else if (!/^[1-9]\d{3}$/.test(this.resume.availableYear)) return alert(`입사가능일자를 확인해주세요.`);
                if (this.resume.availableMonth === '') return alert('입사가능일자를 입력해주세요.');
                else if (!/^(0?[1-9]|1[0-2])$/.test(this.resume.availableMonth)) return alert(`입사가능일자를 확인해주세요.`);
                if (this.resume.availableDay === '') return alert('입사가능일자를 입력해주세요.');
                else if (!/^(0?[1-9]|[12][0-9]|3[01])$/.test(this.resume.availableDay)) return alert(`입사가능일자를 확인해주세요.`);
            }

            for (let item of this.resume.educationList) {
                if (item.school === '') return alert('[학력] 학교명을 입력해주세요.');

                if (item.startYear === '') return alert('[학력] 재학기간을 입력해주세요.');
                else if (!/^[1-9]\d{3}$/.test(item.startYear)) return alert(`[학력] 재학기간을 확인해주세요.`);

                if (item.startMonth === '') return alert('[학력] 재학기간을 입력해주세요.');
                else if (!/^(0?[1-9]|1[0-2])$/.test(item.startMonth)) return alert(`[학력] 재학기간을 확인해주세요.`);

                if (item.endYear === '') return alert('[학력] 재학기간을 입력해주세요.');
                else if (!/^[1-9]\d{3}$/.test(item.endYear)) return alert(`[학력] 재학기간을 확인해주세요.`);

                if (item.endMonth === '') return alert('[학력] 재학기간을 입력해주세요.');
                else if (!/^(0?[1-9]|1[0-2])$/.test(item.endMonth)) return alert(`[학력] 재학기간을 확인해주세요.`);

                if (item.major === '') return alert('[학력] 전공을 입력해주세요.');
                if (item.location === '') return alert('[학력] 소재지를 입력해주세요.');
                if (item.score === '') return alert('[학력] 성적을 입력해주세요.');
            }

            if (this.recruitInfor.cls === '경력') {
                for (let item of this.resume.careerList) {
                    if (item.company === '') return alert('[경력] 회사명을 입력해주세요.');

                    if (item.startYear === '') return alert('[경력] 근무 기간을 입력해주세요.');
                    else if (!/^[1-9]\d{3}$/.test(item.startYear)) return alert(`근무 기간을 확인해주세요.`);

                    if (item.startMonth === '') return alert('[경력] 근무 기간을 입력해주세요.');
                    else if (!/^(0?[1-9]|1[0-2])$/.test(item.startMonth)) return alert(`근무 기간을 확인해주세요.`);

                    if (item.endYear === '') return alert('[경력] 근무 기간을 입력해주세요.');
                    else if (!/^[1-9]\d{3}$/.test(item.endYear)) return alert(`근무 기간을 확인해주세요.`);

                    if (item.endMonth === '') return alert('[경력] 근무 기간을 입력해주세요.');
                    else if (!/^(0?[1-9]|1[0-2])$/.test(item.endMonth)) return alert(`근무 기간을 확인해주세요.`);

                    if (item.position === '') return alert('[경력] 최종직위를 입력해주세요.');
                    if (item.job === '') return alert('[경력] 담당업무를 입력해주세요.');
                    if (item.retireReason === '') return alert('[경력] 퇴직사유를 입력해주세요.');
                }
            }

            for (let item of this.resume.languageList) {
                if (item.testNm === '') return alert('[어학] 시험명을 입력해주세요.');

                if (item.issueYear === '') return alert('[어학] 취득일을 입력해주세요.');
                else if (!/^[1-9]\d{3}$/.test(item.issueYear)) return alert(`[어학] 취득일을 확인해주세요.`);

                if (item.issueMonth === '') return alert('[어학] 취득일을 입력해주세요.');
                else if (!/^(0?[1-9]|1[0-2])$/.test(item.issueMonth)) return alert(`[어학] 취득일을 확인해주세요.`);

                if (item.issueDay === '') return alert('[어학] 취득일을 입력해주세요.');
                else if (!/^(0?[1-9]|[12][0-9]|3[01])$/.test(item.issueDay)) return alert(`[어학] 취득일을 확인해주세요.`);

                if (item.testScore === '') return alert('[어학] 점수(등급)을 입력해주세요.');
                if (item.issueInsti === '') return alert('[어학] 언어를 입력해주세요.');
            }

            for (let item of this.resume.licenseList) {
                if (item.licenseNm === '') return alert('[면허 및 자격증] 자격증명을 입력해주세요.');

                if (item.issueYear === '') return alert('[면허 및 자격증] 취득일을 입력해주세요.');
                else if (!/^[1-9]\d{3}$/.test(item.issueYear)) return alert(`[면허 및 자격증] 취득일을 확인해주세요.`);

                if (item.issueMonth === '') return alert('[면허 및 자격증] 취득일을 입력해주세요.');
                else if (!/^(0?[1-9]|1[0-2])$/.test(item.issueMonth)) return alert(`[면허 및 자격증] 취득일을 확인해주세요.`);

                if (item.issueDay === '') return alert('[면허 및 자격증] 취득일을 입력해주세요.');
                else if (!/^(0?[1-9]|[12][0-9]|3[01])$/.test(item.issueDay)) return alert(`[면허 및 자격증] 취득일을 확인해주세요.`);

                if (item.grade === '') return alert('[면허 및 자격증] 등급을 입력해주세요.');
                if (item.issueInsti === '') return alert('[면허 및 자격증] 발행처를 입력해주세요.');
            }

            for (let item of this.resume.awardList) {
                if (item.awardNm === '') return alert('[수상경력] 수상내역을 입력해주세요.');

                if (item.issueYear === '') return alert('[수상경력] 취득일을 입력해주세요.');
                else if (!/^[1-9]\d{3}$/.test(item.issueYear)) return alert(`[수상경력] 취득일을 확인해주세요.`);

                if (item.issueMonth === '') return alert('[수상경력] 취득일을 입력해주세요.');
                else if (!/^(0?[1-9]|1[0-2])$/.test(item.issueMonth)) return alert(`[수상경력] 취득일을 확인해주세요.`);

                if (item.issueDay === '') return alert('[수상경력] 취득일을 입력해주세요.');
                else if (!/^(0?[1-9]|[12][0-9]|3[01])$/.test(item.issueDay)) return alert(`[수상경력] 취득일을 확인해주세요.`);

                if (item.score === '') return alert('[수상경력] 점수를 입력해주세요.');
                if (item.issueInsti === '') return alert('[수상경력] 단체명을 입력해주세요.');
            }

            for (let item of this.resume.serviceList) {
                if (item.serviceInstitution === '') return alert('[봉사활동] 봉사기관을 입력해주세요.');
                if (item.serviceContent === '') return alert('[봉사내용] 봉사기관을 입력해주세요.');
                if (item.serviceTime === '') return alert('[봉사활동] 봉사 총 시간을 입력해주세요.');
            }

            return true;
        },
        pageCheckThree() {
            if (this.recruitInfor.cls === '신입') {
                if (this.resume.growingUp === '') return alert(`1번 항목을 입력해주세요.`);
                if (this.resume.personality === '') return alert(`2번 항목을 입력해주세요.`);
                if (this.resume.activities === '') return alert(`3번 항목을 입력해주세요.`);
                if (this.resume.specialTalent === '') return alert(`4번 항목을 입력해주세요.`);
                if (this.resume.applyReason === '') return alert(`5번 항목을 입력해주세요.`);
                if (this.resume.philosophyc === '') return alert(`6번 항목을 입력해주세요.`);
            }

            if (this.recruitInfor.cls === '경력') {
                if (this.resume.growingUp === '') return alert(`1번 항목을 입력해주세요.`);
                if (this.resume.personality === '') return alert(`2번 항목을 입력해주세요.`);
                if (this.resume.applyReason === '') return alert(`3번 항목을 입력해주세요.`);
                if (this.resume.philosophyc === '') return alert(`4번 항목을 입력해주세요.`);
                if (this.resume.activities === '') return alert(`5번 항목을 입력해주세요.`);
            }

            if (!this.agreePrivacy || !this.agreeCreditInfoProvision) return alert('필수 개인정보 동의 항목을 모두 체크해주세요.');

            return true;
        },
        toggleConsentModal() {
            this.consentModalOpen = !this.consentModalOpen;
            this.toggleConsentScroll();
        },
        toggleCreditConsentModal() {
            this.creditConsentModalOpen = !this.creditConsentModalOpen;
            this.toggleConsentScroll();
        },
        toggleConsentScroll() {
            if (this.consentModalOpen || this.creditConsentModalOpen) this.$lenis.stop();
            else this.$lenis.start();
        },
        changeImage(event) {
            const files = event.target?.files;
            if (files.length > 0) {
                const file = files[0];
                const reader = new FileReader();
                reader.onload = (e) => (this.previewImage = e.target.result);
                reader.readAsDataURL(file);
            }
        },
        iterableOjb(arr, temp) {
            const add = () => {
                arr.push(JSON.parse(JSON.stringify(temp)));
            };
            const remove = (idx) => {
                if (arr.length >= 0) {
                    arr.splice(idx, 1);
                }
            };
            return {
                add,
                remove,
            };
        },
        execDaumPostcode() {
            new window.daum.Postcode({
                oncomplete: (data) => {
                    if (this.extraAddress !== '') {
                        this.extraAddress = '';
                    }
                    if (data.userSelectedType === 'R') {
                        this.resume.addr1 = data.roadAddress;
                    } else {
                        this.resume.addr1 = data.jibunAddress;
                    }

                    if (data.userSelectedType === 'R') {
                        if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
                            this.extraAddress += data.bname;
                        }
                        if (data.buildingName !== '' && data.apartment === 'Y') {
                            this.extraAddress += this.extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
                        }
                    } else {
                        this.extraAddress = '';
                    }
                    this.resume.zipNo = data.zonecode;
                },
            }).open();
        },
        async submit() {
            if (this.step === 2) if (!this.pageCheckThree()) return;

            if (this.isSubmit) return;
            this.isSubmit = true;

            const resumeDate = JSON.parse(JSON.stringify(this.resume));

            resumeDate.availableDate = `${+resumeDate.availableYear}${String(+resumeDate.availableMonth).padStart(2, 0)}${String(
                +resumeDate.availableDay
            ).padStart(2, 0)}`;
            delete resumeDate.availableYear;
            delete resumeDate.availableMonth;
            delete resumeDate.availableDay;

            resumeDate.birthDate = `${+resumeDate.birth_comp_year}${String(+resumeDate.birth_comp_month).padStart(2, 0)}${String(
                +resumeDate.birth_comp_day
            ).padStart(2, 0)}`;
            delete resumeDate.birth_comp_year;
            delete resumeDate.birth_comp_month;
            delete resumeDate.birth_comp_day;

            resumeDate.hpNo = `${resumeDate.hpNo_comp_first}${resumeDate.hpNo_comp_second}${resumeDate.hpNo_comp_third}`;
            delete resumeDate.hpNo_comp_first;
            delete resumeDate.hpNo_comp_second;
            delete resumeDate.hpNo_comp_third;

            resumeDate.telNo = `${resumeDate.telNo_comp_first}${resumeDate.telNo_comp_second}${resumeDate.telNo_comp_third}`;
            delete resumeDate.telNo_comp_first;
            delete resumeDate.telNo_comp_second;
            delete resumeDate.telNo_comp_third;

            resumeDate.email = `${resumeDate.email_comp_first}@${resumeDate.email_comp_second}`;
            delete resumeDate.email_comp_first;
            delete resumeDate.email_comp_second;

            resumeDate.awardList.forEach((item) => {
                item.issueDate = `${item.issueYear}${String(+item.issueMonth).padStart(2, 0)}${String(+item.issueDay).padStart(2, 0)}`;
                delete item.issueYear;
                delete item.issueMonth;
                delete item.issueDay;
            });

            resumeDate.careerList.forEach((item) => {
                item.startDate = `${item.startYear}${String(+item.startMonth).padStart(2, 0)}`;
                item.endDate = `${item.endYear}${String(+item.endMonth).padStart(2, 0)}`;
                delete item.startYear;
                delete item.startMonth;
                delete item.endYear;
                delete item.endMonth;
            });

            resumeDate.educationList.forEach((item) => {
                item.startDate = `${item.startYear}${String(+item.startMonth).padStart(2, 0)}`;
                item.endDate = `${item.endYear}${String(+item.endMonth).padStart(2, 0)}`;
                delete item.startYear;
                delete item.startMonth;
                delete item.endYear;
                delete item.endMonth;
            });

            resumeDate.languageList.forEach((item) => {
                item.issueDate = `${item.issueYear}${String(+item.issueMonth).padStart(2, 0)}${String(+item.issueDay).padStart(2, 0)}`;
                delete item.issueYear;
                delete item.issueMonth;
                delete item.issueDay;
            });

            resumeDate.licenseList.forEach((item) => {
                item.issueDate = `${item.issueYear}${String(+item.issueMonth).padStart(2, 0)}${String(+item.issueDay).padStart(2, 0)}`;
                delete item.issueYear;
                delete item.issueMonth;
                delete item.issueDay;
            });

            if (this.resumeIdx === '') {
                const formData = new FormData();
                formData.append('resume', JSON.stringify(resumeDate));
                formData.append('file', this.$refs.photo.files[0]);

                const result = await resumeInsertAction(formData);
                if (result.data.status === 'success') {
                    alert('정상적으로 지원되었습니다.');
                    this.$router.push({ path: `/recruit/recruitment_notice` });
                }
            } else {
                const formData = new FormData();
                formData.append('resume', JSON.stringify(resumeDate));
                if (this.$refs.photo.files[0]) formData.append('file', this.$refs.photo.files[0]);

                const result = await resumeUpdate(formData);
                if (result.data.status === 'success') {
                    alert('지원서가 정상적으로 수정되었습니다.');
                    this.$router.push({ path: `/recruit/recruitment_notice` });
                }
            }
        },
        handleSelectChange(e) {
            if (e.target.value === '') {
                this.emailEditable = true;
                this.resume.email_comp_second = '';
            } else {
                this.emailEditable = false;
                this.resume.email_comp_second = e.target.value;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
section {
    padding: 0;
}

input[type='file'] {
    display: none;
}

.job_offer .form_wrap .inner .form_section form .row .picture .inner {
    cursor: pointer;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

button {
    cursor: pointer;
}

input[disabled] {
    color: #999;
}

/* base checkbox styling replicated from seminar modal */
.checkbox_label {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 20px; /* default spacing */

    input[type='checkbox'] {
        display: none;

        &:checked + .check_box {
            border-color: var(--orange);
            background: url(@/assets/check.png) no-repeat center;
        }
    }

    .check_box {
        width: 20px;
        height: 20px;
        border: 1px solid #333;
        display: inline-block;
    }

    span {
        font-size: 15px;
        margin: 0;
        font-weight: 500;
    }
}

.consent_group .checkbox_label {
    margin-left: 0;
}

.consent_group {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.consent_row {
    display: flex;
    align-items: center;
    gap: 20px;
}

.consent_head {
    display: flex;
    align-items: center;
    gap: 10px;

    p {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
    }
}

.consent_desc {
    margin: 0;
    font-size: 14px;
    color: #666;
    margin-top: 4px;
}

.text_btn {
    background: transparent;
    border: none;
    color: var(--orange);
    font-size: 14px;
    text-underline-offset: 3px;
    cursor: pointer;
    padding: 0;
}

.consent_modal {
    .modal_wrapper {
        width: 860px;
        max-width: calc(100% - 40px);
        max-height: calc(100% - 40px);
    }

    .modal_body {
        max-height: 70vh;
    }
}

.consent_content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    color: #222;
    line-height: 1.6;
    font-size: 14px;
}

.consent_title {
    font-weight: 700;
    font-size: 18px;
    margin-bottom: 4px;
}

.consent_sub_title {
    font-weight: 700;
    margin-top: 10px;
}

.consent_table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #ddd;
    margin-top: 6px;

    th,
    td {
        border: 1px solid #ddd;
        padding: 8px;
        vertical-align: top;
        font-size: 13px;
    }

    th {
        background: #f7f7f7;
        font-weight: 700;
    }
}

.consent_notice {
    color: #555;
    font-size: 13px;
}

@media screen and (max-width: 1024px){
    .input_group:has(.military_row) {
        flex-wrap :wrap;

        .info {
            width: 100%;
            margin-left: 0 !important;
            margin-top: 20px !important;

            @media screen and (max-width: 768px){
                margin-top: 0 !important;
            }
        }
        .military_row {
            flex: 1 0 0;
            display: flex;
            align-items: center;
            input {
                flex: 1 0 0 !important;
            }
        }
    }

    .w-250 {
        width: auto;
    }
}

@media screen and (max-width: 768px){
    .input_group {
        flex: 1 0 100% !important;
        input, select {
            flex: 1 0 auto !important;
        }
    }

    .row.military {
        flex-wrap: nowrap;
        flex-direction: row;
        gap: 20px;
        
        .input_group {
            flex: 1 0 0 !important;
            min-width: 0;

            select {
                width: 100%;
            }
        }

        &:has(select){
            .title {
                display: none;
            }
        }
    }

    .military_row {
        width: 100%;
        display: flex;
        align-items: center;
        input {
            flex: 1 0 0;
        }
        .info {
            width: 100%;
            margin-top: 0;
        }
    }

    .row_center {
        flex-direction: row !important;
        align-items: center !important;
    }
}
</style>
